import React, { ReactElement } from "react";
import { Dropdown } from "react-bootstrap";
import { IoEllipsisVertical } from "react-icons/io5";
import { Permission } from "../../../__generated__/api";
import useCurrentSession from "../../../contexts/UserContext";
import CreateAnswerAction from "./create-answer";
import EditMessageAction from "./edit";
import DeleteMessageAction from "./delete";
import Styles from "../Chat.module.scss";

export default function CardActions({
    isAgentMessage, messageText, plainText, isHover, messageId, chatId, isEditable, isDeletable,
}: {
    isAgentMessage: boolean, messageText: string, plainText?: string, isHover?: boolean,
    messageId: string, chatId: string, isEditable: boolean, isDeletable: boolean
}): ReactElement {
    // const [target, setTarget] = useState<HTMLElement>();
    const { permissions } = useCurrentSession();
    return (
        <>
            {/* {target && (
                <EmojiPicker
                    target={target}
                    chatId={chatId}
                    messageId={messageId}
                    onHide={() => setTarget(undefined)}
                    placement={isAgentMessage ? "right" : "left"}
                />
            )} */}
            <div className={`position-absolute top-0 bg-blue-dark rounded mt-n1  ${isAgentMessage
                ? "start-0"
                : "translate-middle-x start-100 ms-n4"} ${isHover ? "d-flex" : "d-none"}`}
            >
                {/* <button
                    className="badge btn btn-none py-2 px-2 text-light"
                    type="button"
                    onClick={evt => {
                        setTarget(target ? undefined : evt.currentTarget);
                    }}
                >
                    <BsEmojiSunglasses />
                </button> */}
                {(permissions.has(Permission.ArticleModify) || permissions.has(Permission.Administrator)) && (
                    <Dropdown>
                        <Dropdown.Toggle
                            variant=""
                            className="menu-small text-white btn btn-sm p-1 px-2"
                        >
                            <IoEllipsisVertical />
                        </Dropdown.Toggle>
                        <Dropdown.Menu className={`bg-blue-dark text-white dropdown-dark ${Styles["menu-container"]}`}>
                            {(isDeletable) && (
                                <>
                                    {isEditable && isDeletable && (
                                        <EditMessageAction
                                            ticketMessageId={messageId}
                                        />
                                    )}
                                    {isDeletable && <DeleteMessageAction text={messageText} ticketMessageId={messageId} />}
                                    <Dropdown.Divider />
                                </>
                            )}

                            <CreateAnswerAction text={messageText} plainText={plainText} />
                        </Dropdown.Menu>
                    </Dropdown>
                )}
            </div>
        </>
    );
}

CardActions.defaultProps = {
    plainText: "",
    isHover: true,
};
